import { TableCell, TableHead, TableRow } from '@material-ui/core'

export const ExtAgsTableHead = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Code</TableCell>
        <TableCell>Date</TableCell>
        <TableCell>Convocation</TableCell>
        <TableCell>Visio Conference</TableCell>
        <TableCell>Pv d’ag</TableCell>
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  )
}
